<app-titledescription [title]="'Titulos'" [description]="'Aca se muestra el listado de titulos'"></app-titledescription>
<app-button
    text="Agregar Título"
    tooltip="Agregar nuevo titulo"
    href="/titulos/create"
    type="button"
></app-button>
<!-- FIXME: its necesary make a template to reuse in all pages -->
<div style="margin-bottom: 20px;">
</div>
<ng-template #table>
  @if(dataFetch) {
    <app-table
      [columnsNames]="columnNames"
      [dataFetch]="dataFetch"
      [totalItems]="totalItems"
      [labelFilter]="'Descripcion'"
      (fetchAgain)="fetchData($event.options, $event.ignoreCache)"
      [actions]="actions"
      [pagination]="true"
      [filterable]="true"
      [apiService]="apiService"
      [paginateOptions]="paginateOptions"
      [pageIndex]="pageIndex"
      [labelSelect]="'Nivel'"
      [dataSelect]="dataSelectNiveles"
      [selectable]="true"
      [mainFilterField]="'nivel_id'"
    ></app-table>
  }
</ng-template>
<app-card [templateRefContent]="table"></app-card>

